import { Link, useNavigate } from "react-router-dom";

import PassTextField from "../../components/Custom/Password/Password";
/* eslint-disable no-useless-escape */
import React from "react";
import { TextField } from "@mui/material";
import { post } from "../../config/axios";
import styles from "./ForgotPassword.module.css";
import { toastMessage } from "../../utils/toastMessage";
const ForgotPassword = (props) => {
  const navigate = useNavigate();
  const [formData, setFormData] = React.useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [formError, setFormError] = React.useState({
    email: false,
    password: false,
  });
  const [loading, setLoading] = React.useState(false);

  const validate = () => {
    let value = true;
    let err = { email: false, password: false, confirmPassword: false };
    let isEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    setFormError({ ...err });
    if (formData.password.length < 6) {
      value = false;
      err.password = "Password should be atleast 8 charactors";

    }
    if (!isEmail.test(formData.email)) {
      err.email = "Enter valid email";
      value = false;

    }
    if (formData.password !== formData.confirmPassword) {
      err.confirmPassword = "confirm password does not match";
      value = false;

    }
    setFormError({ ...err });
    return value
  };

  const onSubmit = async () => {
    if (validate()) {
      setLoading(true);

      let data = { ...formData };
      await post("/api/dashboard/auth/resetpassword", data)
      .then((res) => {
        // localStorage.setItem("token", res.data.token);
        console.log("in response", res);
        if(res?.data){
          toastMessage(res.data.message || res.errorType, "success");
          navigate("/login");
        } else{
          toastMessage(res.errorType, "error");
          return
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setLoading(false); // Ensure loading is false after the request is complete
      })
    }
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h1 className={styles.head}>Admin</h1>
          </div>
          <div className={styles.loginContainer}>
            <div className={styles.loginContent}>
              <h1 className={styles.loginHead}>Reset Password</h1>

              <TextField
                variant="standard"
                fullWidth
                label="Email"
                className={styles.textField}
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                error={formError.email}
                helperText={formError.email}
              />

              <PassTextField
                variant="standard"
                fullWidth
                label="Password"
                className={styles.textField}
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                error={formError.password}
                helperText={formError.password}
              />
              <PassTextField
                variant="standard"
                fullWidth
                label="Confirm Password"
                className={styles.textField}
                value={formData.confirmPassword}
                onChange={(e) =>
                  setFormData({ ...formData, confirmPassword: e.target.value })
                }
                error={formError.confirmPassword}
                helperText={formError.confirmPassword}
              />

              <div className={styles.flex_box}>
                {loading ? (
                  <button className={styles.signIn}>Loading...</button>
                ) : (
                  <button className={styles.signIn} onClick={onSubmit}>
                    Submit
                  </button>
                )}

                <div className={styles.forget_button}>
                  <Link to="/login">Back to Login</Link>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.loginFooter}>&nbsp;</div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
